/**
 * Debug hulpprogramma's voor het inspecteren van de applicatiestatus
 * en het oplossen van problemen.
 */

/**
 * Logger functie met verschillende log levels en tijdstempels
 */
export const logger = {
  debug: (message: string, ...args: any[]) => {
    console.log(`[DEBUG][${new Date().toISOString()}] ${message}`, ...args);
  },
  info: (message: string, ...args: any[]) => {
    console.info(`[INFO][${new Date().toISOString()}] ${message}`, ...args);
  },
  warn: (message: string, ...args: any[]) => {
    console.warn(`[WARN][${new Date().toISOString()}] ${message}`, ...args);
  },
  error: (message: string, ...args: any[]) => {
    console.error(`[ERROR][${new Date().toISOString()}] ${message}`, ...args);
  },
};

/**
 * Setup debug tooling in de globale window object
 */
export const setupDebugTools = () => {
  if (typeof window !== 'undefined') {
    // Maak een globaal debug object aan
    (window as any).debug = {
      // Maak een 'stores' object aan voor het inspecteren van alle stores
      stores: {
        // Zal worden gevuld door de individuele stores
      },
      // Maak een 'inspect' functie aan voor het inspecteren van de gehele applicatiestatus
      inspect: () => {
        const storesInfo: Record<string, any> = {};

        // Verzamel info van alle beschikbare stores
        if ((window as any).debugStores) {
          Object.entries((window as any).debugStores).forEach(([name, store]: [string, any]) => {
            if (store.getState) {
              storesInfo[name] = store.getState();
            }
          });
        }

        return {
          timestamp: new Date().toISOString(),
          url: window.location.href,
          stores: storesInfo,
          envInfo: {
            userAgent: navigator.userAgent,
            language: navigator.language,
            screenSize: `${window.innerWidth}x${window.innerHeight}`,
          },
        };
      },
      // Helper voor het bekijken van websocket status
      websockets: {
        getStatus: () => {
          if ((window as any).debugHooks?.realTimeAssetPreviewUpdates) {
            // Dit werkt alleen als de hook actief is in een component
            return 'Hook is defined but cannot be directly accessed outside React components';
          }
          return 'WebSocket hooks not available';
        },
      },
      // Helper voor het analyseren van de React component tree (niet geïmplementeerd)
      reactTree: () => {
        console.log('React DevTools extension is aanbevolen voor componentanalyse');
      },
      // Functie voor het aanmaken van een volledig debug rapport
      generateReport: () => {
        const report = {
          timestamp: new Date().toISOString(),
          url: window.location.href,
          stores: {},
          envInfo: {
            userAgent: navigator.userAgent,
            language: navigator.language,
            screenSize: `${window.innerWidth}x${window.innerHeight}`,
          },
        };

        if ((window as any).debugStores) {
          Object.entries((window as any).debugStores).forEach(([name, store]: [string, any]) => {
            if (store.getState) {
              (report.stores as any)[name] = store.getState();
            }
          });
        }

        console.log('Debug Report:', report);
        return report;
      },
    };

    console.log('Debug tools geactiveerd. Gebruik window.debug om te inspecteren.');
  }
};

// Automatisch opstarten bij het importeren van deze module
setupDebugTools();
